import { AxiosResponse } from "axios";
import { LatLngTuple } from "leaflet";
import { GeographicalLatLng, IAddress, SearchAddressFilters } from "../type/Address.type";
import qs from "qs";
// @todo modify here with request app.
import request from "./AppRequest";
import { config } from "../config";
import {
  API_SEARCH_LIMIT,
  GEOGRAPHICAL_PRIORITY_DEFAULT,
  MAP_SEARCH_GEO_API_URL,
  MAP_REVERSE_GEO_API_URL
} from "../constants/autocomplete";

export class GeoService {

  public static searchAddress = async (
      address: string,
      geographicalPriority: GeographicalLatLng = GEOGRAPHICAL_PRIORITY_DEFAULT,
      searchFilters?: SearchAddressFilters
    ): Promise<IAddress[]> => {
    let items: IAddress[] = [];
    await request
      .get<IAddress[]>(
        `${MAP_SEARCH_GEO_API_URL}?q=${address}&lat=${geographicalPriority.lat}&lon=${geographicalPriority.lng}&limit=${API_SEARCH_LIMIT}`,
        true,
        true,
        true,
        {},
        true,
      )
      .then((response: AxiosResponse) => {
        // Filter by geographic zone
        let data = response.data.features.filter((addressItem: any) => {
          if (!searchFilters) {
            return addressItem
          }

          return GeoService.isValidAddress(addressItem, searchFilters) ? addressItem : null
        })

        items = data.map((value: any): IAddress => {
          let address: string;
          if ('municipality' === value.properties.type) {
            address = value.properties.city + ' ' + value.properties.postcode;
          } else {
            address = value.properties.label
          }

          return {
            latitude: value.geometry.coordinates[1],
            longitude: value.geometry.coordinates[0],
            address: address,
            number: value.properties.housenumber,
            street: value.properties.street ? value.properties.street : value.properties.name,
            postalCode: value.properties.postcode,
            city: value.properties.city,
            country: "France",
            type: value.properties.type,
          }
        })
      })

    return items
  }

  public static isValidAddress = (addressItem: any, searchFilters: SearchAddressFilters): boolean => {
    if (!searchFilters) {
      return true
    }

    let filters = searchFilters?.departments?.join("|")
    // Api Context return looks like "75, Paris, Île-de-France"
    // Filters departments format is ^(28|75|92)
    if (addressItem.properties.context && addressItem.properties.context.match(`^(${filters})`)) {
      return true
    }

    return false
  }

  public static getAddressFromLatLang = async (lat: number, lng: number): Promise<IAddress[]> => {
    let items: IAddress[] = [];
    await request
      .get<IAddress[]>(`${MAP_REVERSE_GEO_API_URL}?lon=${lng}&lat=${lat}`, true, true, true, {}, true)
      .then((response: AxiosResponse) => {
        items = response.data.features.map((value: any): IAddress => {
          return {
            latitude: value.geometry.coordinates[1],
            longitude: value.geometry.coordinates[0],
            address: value.properties.label,
            number: value.properties.housenumber,
            street: value.properties.street ? value.properties.street : value.properties.name,
            postalCode: value.properties.postcode,
            city: value.properties.city,
            country: "France",
            type: "",
          };
        });
      });
    return items;
  };

  public static isPointInDepartement = async (
    geoserver: {
      url: string;
      workspace: string;
      layer: string;
      authkey?: string;
    },
    point: LatLngTuple,
  ): Promise<boolean> => {
    const query = {
      version: "1.0.0",
      outputFormat: "application/json",
      typeName: `${geoserver.workspace}:${geoserver.layer}`,
      request: "GetFeature",
      service: "WFS",
      authKey: geoserver.authkey,
      CQL_FILTER: (`INTERSECTS(%geoserverPropertyName%, POINT(${point[1]} ${point[0]}))`)
        .replace('%geoserverPropertyName%', config.geoserverPropertyName),
    };
    const queryString = qs.stringify(query);
    return await request
      .get<boolean>(`${geoserver.url}/wfs?${queryString}`, false, true, true, {}, true)
      .then((response: AxiosResponse<any>) => {
        return response.data.numberReturned > 0;
      });
  };
}
